<!-- 各险种理赔情况 -->
<template>
	<div :id="id" class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
import moment from 'moment';
let chart = null;
export default {
	name: 'SettlementInsuranceClaimsChart',
	props: {
		id: {
			type: String,
			required: false,
			default: 'chart'
		},
		subtext: {
			type: String,
			required: false,
			default: moment().format('YYYY年MM月DD日')
		}
	},
	data() {
		return {
			//id: 'completeRateChart',//地图渲染容器id
			option: {
				title: {
					text: '(外圆报案面积占比，内圆理赔面积占比)',//主标题
					textStyle: {
						//主标题的属性
						color: 'rgba(0, 0, 0, 0.4)', //颜色
						fontSize: 12, //大小
					},
					subtext: '(2020年6月4日)',
					left: 'right',
					 // textAlign: 'auto',//整体（包括 text 和 subtext）的水平对齐
				},
				// tooltip: {
				//   trigger: "item",
				//   formatter: "{a} <br/>{b} : {c} ({d}%)"
				// },
				tooltip: {
					trigger: 'item',
					formatter: function(params, ticket, callback) {
						// return params.name + "<br>" + params.percent + '%'
						return params.name + '<br>' + '面积：' + params.value.labelValue + '亩' + '<br>' + '占比：' + params.percent + '%';
					}
				},
				legend: {
					orient: 'vertical',
					right: 10,
					top: '30%',
					bottom: 20,
					itemGap: 20,
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						color: '#333'
					},
					icon: 'rect',
					//data: ['水稻政策性保险', '大豆政策性保险', '玉米政策性保险']
				},
				color: ['#00d5b2', '#1a8dee', '#ff9023','#02C874', '#0000E3', '#8600FF', '#FFDC35', '#80FFFF', '#B766AD', '#FF60AF'],
				series: [
					{
						// name: "",
						type: 'pie',
						radius: ['42%', '60%'],
						center: ['30%', '50%'],
						label: {
							show: false,
							// position: "inside",
							fontSize: 14,
							color: '#666',
							formatter(val) {
								//   return val.value+'亩';
							}
						},

						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						labelLine: {
							show: false
						},
						encode: {
							itemName: 'type',
							value: 'labelValue'
						},
						datasetIndex: 0
					},
					{
						// name: "大豆政策保险完成比列(%)",
						type: 'pie',
						radius: [0, '36%'],
						center: ['30%', '50%'],
						label: {
							show: false,
							// position: "inside",
							fontSize: 14,
							color: '#666',
							formatter(val) {
								//   return val.value+'亩';
							}
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						labelLine: {
							show: false
						},
						datasetIndex: 1,
						encode: {
							itemName: 'type',
							value: 'labelValue'
						}
					},
					
				]
			}
		};
	},
	mounted() {
		//this.initMap()
	},
	watch: {},
	methods: {
		listenResize() {
			//窗口改变大小
			if (chart) {
				chart.resize();
			}
		},
		initMap(optionData) {
			//设置时间
			this.option.title.subtext = optionData.date+'年' || '';
			this.option.dataset = optionData.dataset;
			// this.option.legend.data = optionData.legend
			// this.option.series = optionData.series
			chart = echarts.init(document.getElementById(this.id));
			chart.setOption(this.option);
			if (optionData.chartHeight) {
				chart.resize({ height: optionData.chartHeight });
			} else {
				chart.resize({ height: 300 });
			}
		}
	},
	components: {}
};
</script>

<style scoped lang="less">
.o-echarts {
	min-width: 30px;
	min-height: 30px;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/SettlementInsuranceClaimsChart.vue